import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import type { FC } from "react";
import React from "react";
import { ProSpaceArticle } from "../../../../../../../model/article";
import type { WebhostingArticle } from "../../../../../../../model/article/WebhostingArticle";
import { WebhostingArticleTag } from "../../../../../../../model/article/WebhostingArticle";
import type Bytes from "../../../../../../../model/misc/Bytes";
import type { PromoCode } from "../../../../../../../widgets/utils/promoCode";
import PriceSection from "./components/PriceSection";
import ProSpaceLiteSection from "./components/WebhostingSection";

interface Props {
  selectedArticle: ProSpaceArticle | WebhostingArticle;
  watchedStorageSize: Bytes;
  freeTrial: boolean;
  promotion?: PromoCode;
}

export const OrderPreviewBox: FC<Props> = (props) => {
  const { selectedArticle, watchedStorageSize, freeTrial, promotion } = props;
  const isProSpaceProject = selectedArticle instanceof ProSpaceArticle;
  const webhostingArticle = !isProSpaceProject ? selectedArticle : null;

  return (
    <TranslationProvider name="projectOrderPreviewBox" type="component">
      {!isProSpaceProject && webhostingArticle && (
        <>
          {webhostingArticle.articleTag === WebhostingArticleTag.webhosting && (
            <ProSpaceLiteSection />
          )}
        </>
      )}

      <PriceSection
        freeTrial={freeTrial}
        promotion={promotion}
        selectedArticle={selectedArticle}
        watchedStorageSize={watchedStorageSize}
      />
    </TranslationProvider>
  );
};

export default OrderPreviewBox;
